(function(window) {
    if ($('.stat-3').length <= 0) {
        return;
    }

    let subheader = $('.stat-3__sub-header');

    if (subheader) {
        let subheaderLength = $(subheader)
            .text()
            .trim().length;
        if (subheaderLength == 0) {
            subheader.remove();
        }
    }

    if ($('.stat-3__item').length == 1) {
        $('.stat-3__dots__list').remove();
        return;
    }

    if ($('.stat-3__item').length == 2) {
        $('.stat-3__dots__list li:last-child').remove();
    }

    let stat3Items = $('.stat-3__items');

    let statDotButtons = $('.stat-3__dots button');

    function dotsUpdate() {
        stat3Items = $('.stat-3__items');
        statsDotsListItem = $('.stat-3__dots__list__item');

        let slideWidth = $(stat3Items[0]).width();
        let scroll = stat3Items[0].scrollLeft;
        let newActive = Math.round(scroll / slideWidth);

        $('.stat-3__dots__list__item.-active').removeClass('-active');
        statsDotsListItem[newActive].classList.add('-active');
    }

    function dotsClickUpdate() {
        let slideWidth = $(stat3Items[0]).width();
        let currentItem = this;
        let scrollLeft = slideWidth * $(this).attr('data-index');
        $('.stat-3__dots__list__item.-active').removeClass('-active');
        currentItem.parentElement.classList.add('-active');
        $('.stat-3__items').scrollLeft(scrollLeft);
    }

    stat3Items.on('scroll', dotsUpdate);
    statDotButtons.on('click', dotsClickUpdate);
})(window);
